export default __webpack_public_path__ + "static/media/navBG.1abc3572.jpg";